import axios                        from 'axios';
import store                        from '../';
import {router}                     from '../../router/router.js'
import {addItemUrl, apiDomain}     from '../../config';
import { functions } from '../../functions';
import { EventBus } from '../../eventBus';

const state = {
    currentPartType: '',
    attribs: {
    },
    filtersSortHub:  {
        cpu:            {brand:      ['AMD', 'Intel'],               Number_of_Cores:    ['4 Cores', '6 Cores', '8 Cores'],  RAM_Type:      ['DDR4', 'DDR3']},
        motherboard:    {socket:     ['AM4', 'LGA1156', 'LGA1155'],  RAM_Type:           ['DDR4', 'DDR3']},
        ram:            {capacity:   ['16GB', '32GB', '8GB'],        RAM_Type:           ['DDR4', 'DDR3']},
        storage:        {type:       ['SSD', 'HDD'],                 compat_interface:   ['SATA', 'NVME', 'M.2 SATA'],       Capacity: ['4TB', '8TB']},
        graphics:       {graphics_processor: ['GeForce', 'RadeOn'],  graphics_ram_capacity: ['8GB'],                         memory_bus_width: ['256 bit', '192 bit'], },
        psu:            {form_factor:['ATX'],                        wattage:            ['600W', '1200W'],                  brand:    ['EVGA', 'Corsair']},
        case:           {form_factor:['ATX', 'miniATX', 'microATX'], material:           ['Tempered Glass'],                 features: ['RGB']},
    },
    filtersHub:  {
        cpu:            ['AMD', 'Intel', '4 Cores', '6 Cores', '8 Cores','DDR4', 'DDR3'],
        motherboard:    ['AMD', 'Intel', 'AM4', 'LGA1156', 'LGA1155', 'DDR4', 'DDR3'],
        ram:            ['16GB', '32GB', '8GB', 'DDR4', 'DDR3'],
        storage:        ['SSD', 'HDD', 'SATA', 'NVME', 'M.2 SATA', '2TB', '1TB'],
        graphics:       ['GeForce', 'RadeOn', 'RTX2060', 'nVidia', 'ATI', '8GB', '256bit', '192bit'],
        psu:            ['ATX', '600W', '1200W', 'EVGA', 'Corsair'],
        case:           ['ATX', 'Tempered Glass', 'RGB', 'miniATX', 'microATX'],
    },
    searchFilters: null,
    processors: {
        attribs: { // Attribs are used to display keys in specifications list
            general: [
                "asin",
                "type",
                "model",
                "description",
                "amzn_price",
                "amzn_link"
            ],
            specifications: [
                "Core Frequency",
                "Turbo Frequency",
                "Number of Cores",
                "Number of Threads",
                "Bus Speed",
                "Cache Memory",
                "Max Memory Size",
                "ECC Support",
                "Hyper-Threading",
                "Turbo Boost",
            ],
            compats: [
                "brand",
                "socket",
                // "chipset",
                "ram",
                "ram_speed",
                "processor_generation",
                "tdp"
            ]
        },
    },
    motherboards: {
        attribs: {
            general: [
                "asin",
                "type",
                "brand",
                "model",
                // 'usability',
                "description",
                "form_factor",
                // "features",
                "amzn_price",
                "amzn_link"
            ],
            specifications: [
                "Compatible Memory",
                // "Bus Speed",
                "Socket",
                "WiFi",
                "Integrated_Graphics",
                "USB",
                "Max Memory Size",
                "ECC Support"
            ],
            compats: [
                "processor_generation",
                "socket",
                // "chipset",
                "m_2",
                "M_2_Slot",
                "ram",
                "ram_speed",
                "ram_slots",
                "form_factor",
                "pci_e",
                "sata_slots",
                "sata_speed",
                "pci_e_slots",
                "tdp",
                "nvme",
                'pci_e_x1',
                'pci_e_x4',
                'pci_e_x8',
                'pci_e_x16',
                'cpu_brand',
            ],
        },
    },
    ram: {
        attribs: { // Attribs are used to display keys in specifications list
            general: [
                "asin",
                "type",
                "model",
                "brand",
                'number_of_items',
                "description",
                "features",
                "amzn_price",
                "amzn_link"
            ],
            specifications: [
                "Capacity",
                "RAM_Speed",
                "RAM_Type",
                "ECC",
                "Pins",
                "Number_of_Sticks",
            ],
            compats: [
                "number_of_items",
                "ram_type",
                "capacity",
                "ram_speed",
                "Pins",
                "ECC",
                "tdp"
            ]
        },
    },
    storage: {
        attribs: { // Attribs are used to display keys in specifications list
            general: [
                "asin",
                "type",
                "brand",
                "model",
                'number_of_items',
                "description",
                // "features",
                "amzn_price",
                "amzn_link"
            ],
            specifications: [
                "Disk_Type",
                "Capacity",
                "size",
                "hardware_interface",
                "data_transfer_rate",
            ],
            compats: [
                "compat_interface",
                "size",
                "speed",
                'tdp'
            ]
        },
    },
    gpus: {
        attribs: { // Attribs are used to display keys in specifications list
            general: [
                "asin",
                "type",
                "model",
                'brand',
                "description",
                // "features",
                "amzn_price",
                "amzn_link"
            ],
            specifications: [
                "graphics_processor",
                "GPU_clock_speed",
                "graphics_ram_type",
                "graphics_ram_capacity",
                "memory_bus_width",
                "memory_clock_speed",
                "memory_transfer_speed",
                "graphics_interface",
                // "connections",
                // "power_consumption",
                "VR",
            ],
            compats: [
                "graphics_interface",
                // "psu",
                // "form_factor",
                // "power_connector",
                "tdp"
            ]
        },
    },
    psus: {
        attribs: { // Attribs are used to display keys in specifications list
            general: [
                "asin",
                "type",
                "model",
                "brand",
                "description",
                // "features",
                "amzn_price",
                "amzn_link"
            ],
            specifications: [
                "wattage",
                "modular",
                "eco_mode",
                "energy_rating",
            ],
            compats: [
                "wattage",
                "form_factor",
            ]
        },
    },
    cases: {
        attribs: { // Attribs are used to display keys in specifications list
            general: [
                "asin",
                "type",
                "model",
                'brand',
                "description",
                // "features",
                "amzn_price",
                "amzn_link"
            ],
            specifications: [
                "tempered_glass",
                "form_factor",
                "dimentions",
                "weight",
                "I_O_ports",
                "expansion_slots",
                "color",
            ],
            compats: [
                "form_factor",
            ]
        },
    },
    accessories: {
        attribs: { // Attribs are used to display keys in specifications list
            general: [
                "asin",
                "type",
                "model",
                "benchmark",
                'usability',
                "description",
                // "features",
                "amzn_price",
                "amzn_link"
            ],
            specifications: [
                "CPU-Z Benchmark",
                "Core Frequency",
                "Number of Cores",
                "Number of Threads",
                "Generation",
                "Compatible Memory",
                "Bus Speed",
                "Socket",
                "Cache Memory",
                "Max Memory Size",
                "ECC Support",
                "Hyper-Threading",
                "Turbo Boost",
                "TDP",
            ],
            compats: [
                "brand",
                "socket",
                "chipset",
                "motherboard",
                "ram",
                "ram speed",
            ]
        },
    },
    item:null,
    itemLoaded: false,
    items: null,
    itemsLoaded: false,
    message: '',
    loading: false,
    layout: 'demo',
    maxScores: {},
    sortBy: [
        {
            id: 1,
            name: "Price: Low to High",
            chosen: true
        },
        {
            id: 2,
            name: "Price: High to Low",
            chosen: false
        },
        {
            id: 4,
            name: "Performance: Low to High",
            chosen: false
        },
        {
            id: 5,
            name: "Performance: High to Low",
            chosen: false
        },
    ],
};

const getters = {
    getSortBy:              (state) => state.sortBy,
    getMaxScores:           (state) => state.maxScores,
    getFiltersSortHub:      (state) => state.filtersSortHub,
    getSearchFilters:       (state) => state.searchFilters,
    getPartLoading:         (state) => state.loading,
    getMessage:             (state) => state.message,
    getAttribs:             (state) => state.attribs,
    getCurrentPartType:     (state) => state.currentPartType,
    getItems:               (state) => {         
            switch(store.getters.lastRoute.replace(/\\|\/builder\//g,'') ) {
                case 'cpu':
                    return state.processors;
                case 'motherboard':
                    return state.motherboards;
                case 'ram':
                    return state.ram;
                case 'storage':
                    return state.storage;
                case 'graphics' || 'gpu' || 'gpus':
                    return state.gpus;
                case 'psu':
                    return state.psus;
                case 'case':
                    return state.cases;
                case 'accessories':
                    return state.accessories;

                default:
            }
    },
    getItem:                (state) => state.item,
    getItemLoaded:          (state) => state.itemLoaded,
    getFetchedItems:        (state) => state.items,
    allProcessors:          (state) => state.processors,
    allMotherboards:        (state) => state.motherboards,
    allRam:                 (state) => state.ram,
    allStorage:             (state) => state.storage,
    allGpus:                (state) => state.gpus,
    allPsus:                (state) => state.psus,
    allCases:               (state) => state.cases,
    allAccessories:         (state) => state.motherboards,
    allItemsLoaded:         (state) => state.itemsLoaded,
    getLayout:              (state) => state.layout,
};

const actions = {
    updateSortBy({commit}, value){
        commit('UPDATE_SORT_BY', value)
    },
    setLayout               ({commit}, layout){
        commit('UPDATE_LAYOUT', layout)
        console.log('layout changed to ', layout)
    },
    clearSavedForm          ({commit}, type){
        localStorage['saved'+type+'Form'] = ''
        console.log(type +' form cleared')
    },
    setSearchFilters        ({commit}, type){
        commit('RECORD_SEARCH_FILTER', type)
    },
    async addItem           ({commit}, postData){
        commit('LOADING_TRUE')
        commit('UPDATE_MESSAGE', 'Processing...')
        console.log("ADD ITEM FROM STORE, sending ", postData)
        return await axios({
            url: `${apiDomain}additem`, 
            method: "post",
            headers: {
              'Content-Type': `application/json`,
              'Authorization': `Bearer ${localStorage.usertoken}`,
              'alg': "HS256",
              'typ': "JWT"
            },
            data: postData
          }).then((response) => {
            var message = 'Item Updated Successfully! Redirecting...'
            console.log('ADD ITEM response ', response)
            commit('UPDATE_MESSAGE', message)
            store.dispatch('clearSavedForm', postData.type)
            commit('ITEMS_LOADED_FALSE')
            setTimeout(() => {
                commit('LOADING_FALSE')
                router.push({path: '/users/items-controller/items?type='+postData.type}).catch(()=>{});
                store.dispatch('fetchItems', postData.type)
              }, 1500);
            return response;
          }, (error) => {
              console.log(postData)
              store.dispatch('setError', error)
              commit('UPDATE_MESSAGE', 'Error, see console for details');
              setTimeout(() => {
                commit('LOADING_FALSE')
              }, 6000);
            console.log(error)
          })
    },
    async editItem          ({commit}, postData){
        commit('LOADING_TRUE')
        commit('UPDATE_MESSAGE', 'Processing...')
        return await axios({
            url: `${apiDomain}update`, 
            method: "put",
            headers: {
              'Content-Type': `application/json`,
              'Authorization': `Bearer ${localStorage.usertoken}`,
              'alg': "HS256",
              'typ': "JWT"
            },
            data: postData
          }).then(async (response) => {
              console.log('EDIT ITEM response ', response)
              store.dispatch('setCurrentPartType', response.data.part[0].type)
              await store.dispatch('fetchItems', response.data.part[0].type)
              var message = 'Item Updated Successfully! Redirecting...'
              commit('UPDATE_MESSAGE', message)
              setTimeout(() => {
                commit('LOADING_FALSE')
                router.push({path: '/users/items-controller/items?type='+response.data.part[0].type}).catch(()=>{});
              }, 1500);
            // console.log('edit successful')
            return response;
          }, (error) => {
            //   console.log(postData)
            store.dispatch('setError', error)
              commit('UPDATE_MESSAGE', 'Error, see console for details');
              commit('ITEMS_LOADED_FALSE')
              setTimeout(() => {
                commit('LOADING_FALSE')
                router.push({path: '/users/items-controller/items?type='+response.data.part[0].type}).catch(()=>{});
              }, 1500);
            console.error(error)
          })
    },
    async addPart           ({commit}){
        commit('createProcessor')
    },
    setPartAttribs          ({commit}){
        commit('setAttribs')
    },
    setCurrentPartType      ({commit}, type){
        if(type && type !== ''){
            type = type.toLowerCase()
        }
        localStorage.setItem('currentPartType', type)
        commit('updateCurrentType', type)
    },
    async fetchItems        ({commit}, type){
        console.log("FETCH ITEMS FIRED", type)
        // console.log("got type ", type)
        if(state.currentPartType == 'gpu'){
            commit('updateCurrentType', 'graphics')
        }
        if(type == 'gpu'){
            commit('updateCurrentType', 'graphics')
        }
        commit('ITEMS_LOADED_FALSE')
        return await axios ({
            url: `${apiDomain}items?type=${type ? type : state.currentPartType}`,
            method: "get",
        }).then((response) => { 
            //process main image
            var partsList = response.data.partslist.map((itme) => {
                if (JSON.parse(itme.imgUrl)[0].includes('<a href')) { 
                    itme.mainImg = JSON.parse(itme.imgUrl)[1]
                    return itme
                }
                else return itme
            })
            console.log('FETCHING ITEMS', partsList)
            
            store.dispatch('sortItems', store.dispatch('sortItems', {option: localStorage.sortBy ? JSON.parse(localStorage.sortBy) : {id: 1,name: "Price: Low to High",chosen: true}, items: partsList}))
            commit('ITEMS_LOADED_TRUE')
            commit('UPDATE_MESSAGE', '')
        }, () => {
            commit('UPDATE_MESSAGE', 'Could not load...');
        })
    },
    async setChosen         ({ commit }, item){
        commit('selectItem', item);
    },
    setItems                ({commit}, items){
        console.log('SETTING ITEMS', items)
        store.dispatch('sortItems', {option: localStorage.sortBy ? JSON.parse(localStorage.sortBy) : {id: 1,name: "Price: Low to High",chosen: true}, items: items})
    },
    setItem                 ({commit}, item){
        commit('SET_ITEM', item)
        commit('ITEM_LOADED_TRUE')
    },
    unsetItem                 ({commit}){
        commit('UNSET_ITEM')
        commit('ITEM_LOADED_FALSE')
    },
    itemsLoaded({commit}, bool){
        if(bool == false){
            commit("ITEM_LOADED_FALSE")
        }
        else if(bool == true){
            commit("ITEM_LOADED_TRUE")
        }
    },
    async deletePart        ({commit}, data){
        return await axios({
          url: `${apiDomain}single`, 
          method: 'delete',
          headers: {
            'Content-Type': `application/json`,
            'Authorization': `Bearer ${localStorage.usertoken}`,
            'alg': "HS256",
            'typ': "JWT"
          },
          data: JSON.stringify(data)
        }).then((response) => {
          return response;
        }, (error) => {
          commit('NEW_ERROR', error)
        })
    },
    sortItems({commit, state},{option, items}){
        if(option && items){
            var result = []
            if(items && typeof(items) == 'string'){
                result = [...JSON.parse(items)]
            }
            else if(items && typeof(items) == 'object'){
                result = [...items]
            }
            var sortOptions = [...state.sortBy]
                       this.sortByClicked = false;
            for (var i = 0; i<sortOptions.length; i++){
                if(option.name == sortOptions[i].name){
                    sortOptions[i].chosen = true;
                }
                else {
                    sortOptions[i].chosen = false
                }
            }
            commit('UPDATE_SORT_BY', sortOptions)
            // option.chosen = true;
            switch(option.name){
                case ('Price: Low to High'):
                    result.sort((a, b) => (parseInt(a.amzn_price) > parseInt(b.amzn_price)) ? 1:-1)
                    localStorage.sortBy = JSON.stringify(option)
                    break;
                case ('Price: High to Low'):
                    result.sort((a, b) => (parseInt(a.amzn_price) < parseInt(b.amzn_price)) ? 1:-1)
                    localStorage.sortBy = JSON.stringify(option)
                    break;
                case ('Performance: Low to High'):
                    result.sort((a, b) => (a.performance > b.performance) ? 1:-1)
                    localStorage.sortBy = JSON.stringify(option)
                    break;
                case ('Performance: High to Low'):
                    result.sort((a, b) => (a.performance < b.performance) ? 1:-1)
                    localStorage.sortBy = JSON.stringify(option)
                    break;                
            }
            commit('assigningItems', result)
        }
    },
};

const mutations = {
    UPDATE_SORT_BY(state, value){
        state.sortBy = [...value]
    },
    SET_MAX_SCORE(state, {type, score}){
        state.maxScore[type] = score
    },
    RECORD_SEARCH_FILTER    (state, type){
        state.searchFilters = state.filtersHub[type]
    },
    UPDATE_LAYOUT           (state, layout){
        state.layout = layout
    },
    LOADING_TRUE            (state){
        state.loading = true
    },
    LOADING_FALSE           (state){
        state.loading = false
    },
    UPDATE_MESSAGE          (state, newMessage){
        state.message = newMessage
    },
    ITEMS_LOADED_TRUE       (state){
        state.itemsLoaded = true
    },
    ITEMS_LOADED_FALSE      (state){
        state.itemsLoaded = false
    },
    ITEM_LOADED_TRUE        (state){
        state.itemLoaded = true
    },
    ITEM_LOADED_FALSE        (state){
        state.itemLoaded = false
    },
    SET_ITEM                (state, item){
        state.item = item
        // console.log('item is set!')
    },
    UNSET_ITEM              (state){
        state.item = null
    },
    createPart:             (state) => {
        return new Promise(async (resolve, reject) => {
            try {
              const { data } = await axios.post(addItemUrl, state.attribs)
            //   console.log(data)
              resolve(data)
            }catch(e){
                // console.error(e)
              reject(e)
            }
          })
    },
    updateCurrentType:      (state, type) => {
        // console.log('received '+ type)
        state.currentPartType = type
    },
    assigningItems:         (state, items) => {
        if(items){
            var localItems = _.cloneDeep(items)
            var checkedList = localItems.map((item) => item.specs && item.compat ? item : null)
            var scores = {}
            var maxScores = {}
            checkedList.map(async (item)=>{
                if(item && item.type && item.specs && item.compat){
                    var perfIndex = 0;
                    var type = item.type
                    functions.createCompatTable({build: store.getters.allMenuOptions, checkItem: item})
                    if(!scores[type]){
                        scores[type] = []
                    }
                    switch(type){
                        case 'cpu':
                            var frequency   = parseFloat(item.specs[ 'Core_Frequency'    ]);
                            var Turbo       = parseFloat(item.specs[ 'Turbo_Frequency'    ]);
                            var cores       = parseInt(item.specs[   'Number_of_Cores'   ]);
                            var turbo       = parseFloat(item.specs[ 'Turbo_Boost'       ]);
                            var hyper       = item.specs[            'Hyper_Threading'   ];
                            if(frequency && frequency > 1000){
                                frequency = frequency/1000
                            }
                            if(Turbo && Turbo > 1000){
                                Turbo = Turbo/1000
                            }
                            if(turbo == true){
                                frequency = Turbo
                            }
                            perfIndex = frequency*cores
                            // increase by 30% If Hyper-Threading
                            if(typeof(hyper) == 'string' && hyper !== '' && hyper !== 'No'){
                                perfIndex += perfIndex *0.3
                            }
                            if(typeof(turbo) == 'string' && turbo !== '' && turbo !== 'No'){
                                perfIndex += perfIndex *(1/frequency)
                            }
                            // increase by % if Turbo Boost
                            item['performance'] =  perfIndex
                            break
                        case 'graphics' || 'gpu':
                            var core_freqency           = parseFloat(item.specs [ 'GPU_clock_speed'     ]);
                            // var mem_clock               = parseInt(item.specs   [ 'memory_clock_speed'  ]);
                            // var memory_bus_width        = parseFloat(item.specs [ 'memory_bus_width'    ]);
                            // var graphics_ram_type       = parseFloat(item.specs[  'graphics_ram_type'   ]);
                            var graphics_ram_capacity   = parseFloat(item.specs[  'graphics_ram_capacity'   ]);
                            var memory_transfer_speed   = parseFloat(item.specs[  'memory_transfer_speed'   ]);
                            // console.log('calculating gpu performance, core clock: ', core_freqency, ' memory transfer speed: ', memory_transfer_speed)
                            perfIndex = ((memory_transfer_speed)*(core_freqency*graphics_ram_capacity/1000)) * 0.21
                            // console.log('perf score: ', perfIndex)
                            item['performance'] =  perfIndex
                            break
                        case 'ram':
                            item['performance'] = (parseFloat(item.compat.capacity)*0.5)
                            // console.log(item, 'RAM ITEM')
                            break
                        

                    }
                    scores[type].push(perfIndex)
                }
                // var checkedItem = await store.dispatch('isCompatible', item)
                var checkedItem;
                // console.log(checkedItem)
                if(checkedItem == true){
                    item['compatible'] = true;
                }
                else item['compatible'] = false;
            })
            // performance
            console.log("PERF SCORES TABLE: ", scores)
            Object.keys(scores).map(type => {
                maxScores[type] = scores[type].sort((a,b) => b-a)[0]
                var sorted = scores[type].sort((a,b) => b-a)
                var maxAvg = (sorted[0]+sorted[1]+sorted[2]+sorted[3]+sorted[4]+sorted[5]+sorted[6]+sorted[7]+sorted[8]+sorted[9])/10
                state.maxScores[type] = maxAvg
            })
            console.log("Max scores: ", maxScores)
            state.items = [...localItems]
        }
    },
    selectItem:             (state, item) => {
        for(var i =0; i<state.items.length; i++){
            state.items[i].chosen = false;
            if(state.items[i] == item){
                state.items[i].chosen = true
                item.chosen = true;
            }
        } 
    },
    setAttribs:             (state) => {
        switch(state.currentPartType.toLowerCase() ) {
            case 'cpu':
                state.attribs = state.processors.attribs
                // console.log('cpu attribs assigned', state.attribs)
                return state.processors;
            case 'motherboard':
                state.attribs = state.motherboards.attribs
                // console.log('MB attribs assigned', state.attribs)
                return state.motherboards;
            case 'ram':
                state.attribs = state.ram.attribs
                // console.log('ram attribs assigned', state.attribs)
                return state.ram;
            case 'storage':
                state.attribs = state.storage.attribs
                // console.log('storage attribs assigned', state.attribs)
                return state.storage;
            case 'graphics' || 'gpu':
                state.attribs = state.gpus.attribs
                // console.log('gpu attribs assigned', state.attribs)
                return state.gpus;
            case 'psu':
                state.attribs = state.psus.attribs
                // console.log('psu attribs assigned', state.attribs)
                return state.psus;
            case 'case':
                state.attribs = state.cases.attribs
                // console.log('cases attribs assigned', state.attribs)
                return state.cases;
            case 'accessories':
                state.attribs = state.accessories.attribs
                // console.log('accessories attribs assigned', state.attribs)
                return state.accessories;
            default:
        }
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}